(function () {
  var initialized = new WeakSet();

  function getColumnCount(grid) {
    var filterType = grid.getAttribute('data-filter-type');
    var desktop = parseInt(grid.getAttribute('data-columns-desktop') || '2', 10);
    var mobile = parseInt(grid.getAttribute('data-columns-mobile') || '1', 10);
    var isVerticalNarrow =
      filterType === 'vertical' && window.matchMedia('(max-width: 1050px)').matches;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isVerticalNarrow) return 1;
    return isMobile ? mobile : desktop;
  }

  function ensureColumns(grid, count) {
    var columns = grid.querySelectorAll('.mhi-grid-column');
    if (columns.length === count) return;

    var items = [];
    Array.prototype.forEach.call(grid.children, function (child) {
      if (child.classList.contains('mhi-grid-column')) {
        Array.prototype.forEach.call(child.children, function (item) {
          if (item.classList.contains('grid__item')) items.push(item);
        });
      } else if (child.classList.contains('grid__item')) {
        items.push(child);
      }
    });

    grid.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var col = document.createElement('div');
      col.className = 'mhi-grid-column';
      col.setAttribute('data-column', String(i + 1));
      grid.appendChild(col);
    }

    distributeItems(grid, items);
  }

  function distributeItems(grid, items) {
    var columns = grid.querySelectorAll('.mhi-grid-column');
    if (!columns.length) return;

    items.forEach(function (item) {
      var shortest = columns[0];
      for (var i = 1; i < columns.length; i++) {
        if (columns[i].children.length < shortest.children.length) {
          shortest = columns[i];
        }
      }
      shortest.appendChild(item);
    });
  }

  function collectLooseItems(grid) {
    var items = [];
    Array.prototype.forEach.call(grid.children, function (child) {
      if (child.classList.contains('grid__item')) items.push(child);
    });
    return items;
  }

  function initGridColumns(grid) {
    if (initialized.has(grid)) return;
    initialized.add(grid);

    var count = getColumnCount(grid);
    ensureColumns(grid, count);

    var loose = collectLooseItems(grid);
    if (loose.length) distributeItems(grid, loose);

    var observer = new MutationObserver(function (mutations) {
      var added = [];
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1 && node.classList.contains('grid__item')) {
            added.push(node);
          }
        });
      });
      if (added.length) distributeItems(grid, added);
    });

    observer.observe(grid, { childList: true });
  }

  function initAllGrids() {
    var grids = document.querySelectorAll('[data-mhi-grid="columns"]');
    if (!grids.length) return;

    grids.forEach(function (grid) {
      initGridColumns(grid);
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-mhi-grid="columns"]').forEach(function (grid) {
        var nextCount = getColumnCount(grid);
        ensureColumns(grid, nextCount);
      });
    });
  }

  function observeNewGrids() {
    var observer = new MutationObserver(function (mutations) {
      var shouldInit = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
          shouldInit = true;
        }
      });

      if (shouldInit) initAllGrids();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllGrids();
      observeNewGrids();
    });
  } else {
    initAllGrids();
    observeNewGrids();
  }
})();
